import { Divider, Form, InputLabel, Space } from '@procurify/ui'

import { PriceFormField } from '@webapp/components/PriceField'
import { CurrencySelect } from '@webapp/core/components/CurrencySelect'
import {
  type Currency,
  type CurrencyName,
} from '@webapp/core/entities/external/Currency'
import { useProcurifyIntl } from '@webapp/hooks'
import { TaxFields } from './TaxFields'
import messages from '../messages'

interface AirfareFieldsProps {
  currencyName: CurrencyName
  selectedCurrency: Currency | null
  onCurrencyChange: (currency: Currency | null) => void
  isSubmitting: boolean
}

export const AirfareFields = ({
  currencyName,
  selectedCurrency,
  onCurrencyChange,
  isSubmitting,
}: AirfareFieldsProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space>
      <Space direction='horizontal'>
        <Space.Item width={1 / 2}>
          <Form.TextField
            id='airline'
            name='airline'
            label={intl.formatMessage(messages.airlineLabel)}
            disabled={isSubmitting}
          />
        </Space.Item>
        <Space.Item width={1 / 2}>
          <Form.TextField
            id='ticketNumber'
            name='ticketNumber'
            label={intl.formatMessage(messages.ticketNumberLabel)}
            disabled={isSubmitting}
          />
        </Space.Item>
      </Space>

      <Space direction='horizontal'>
        <Space.Item width={1 / 2}>
          <Form.SingleDatePicker
            id='departureDate'
            name='departureDate'
            label={intl.formatMessage(messages.departureDateLabel)}
            disabled={isSubmitting}
            fullWidth
          />
        </Space.Item>
        <Space.Item width={1 / 2}>
          <Form.SingleDatePicker
            id='arrivalDate'
            name='arrivalDate'
            label={intl.formatMessage(messages.arrivalDateLabel)}
            disabled={isSubmitting}
            fullWidth
          />
        </Space.Item>
      </Space>

      <Divider />

      <Space align='center' justify='end' direction='horizontal'>
        <Space.Item>
          <InputLabel htmlFor='subtotal-airfare'>
            {intl.formatMessage(messages.subtotalLabel)}
          </InputLabel>
        </Space.Item>
        <Space.Item width={1 / 3}>
          <PriceFormField
            id='subtotal-airfare'
            name='subtotal'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
        <Space.Item width={1 / 3}>
          <CurrencySelect
            inputId='airfareFields-currency-select'
            value={selectedCurrency}
            onChange={onCurrencyChange}
            isDisabled={isSubmitting}
            menuPortalTarget={document.body}
          />
        </Space.Item>
      </Space>

      <TaxFields isSubmitting={isSubmitting} />

      <Space align='center' direction='horizontal' justify='end'>
        <Space.Item>
          <InputLabel>{intl.formatMessage(messages.totalCostLabel)}</InputLabel>
        </Space.Item>
        <Space.Item width={1 / 3}>
          <PriceFormField
            id='totalCost'
            name='totalCost'
            disabled={isSubmitting}
            inputProps={{ style: { textAlign: 'right' } }}
          />
        </Space.Item>
        <Space.Item width={1 / 3}>{currencyName}</Space.Item>
      </Space>
    </Space>
  )
}
